<template>
  <div class="w-full flex flex-row">
    <div class="w-full flex items-center">
      <b>Cruz Del Sur </b>

      <vs-chip
        class="ml-2 w-1/3"
        :color="cdSurAccountStatus && cdSurAccountStatus.color"
      >
        {{ cdSurAccountStatus && cdSurAccountStatus.name }}
        </vs-chip>
    </div>

    <div class="w-full flex justify-start items-center">
      <b class="w-1/2 text-center">Mercado Libre</b>
      <vs-chip
        class="w-1/3"
        :color="meliAccountStatus && meliAccountStatus.color"
      >{{ meliAccountStatus && meliAccountStatus.name }}</vs-chip>
    </div>

    
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'connection-status',
  computed: {
    authUser() {
      return this.$store.state.authUser;
    },
    /*meliStatus(){
      return this.authUser.meli_access_token ? 'activo' : '' 
    },*/
    ...mapGetters({
      //authUser: 'authUser',
      isLogged: 'isUserLoggedIn',
      cdSurAccountStatus: 'cdSurAccountStatus',
      meliAccountStatus: 'meliAccountStatus'
    })
  }
}
</script>